import IState from '@/store/modules/sections/IState.ts'

const state: IState = {
    sections: [],
}

export default state
